import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const initialState = {
    status: null,
    message: null,
    dataFilter: null,
    channelMapping: null,
    finalData: null,
    locale: null,
    struConfigId: null
}


export const saveResponse = createAsyncThunk("saveResponse", async (credentials) => {
    try {
        const response = await fetch(`/api/saveFilter`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(credentials)
        })
        if (!response.ok) {
            throw new Error('Failed to save the filters');
        }
        return await response.json();
    } catch (error) {
        throw new Error('Failed to save the filters', error);
    }
});

export const saveDataFilter = createAsyncThunk("saveDataFilter", async (data) => {
    return data;
});

export const saveFilters = createAsyncThunk("saveFilters", async (credentials, { getState }) => {
    const currentState = getState();
    let request = {};
    if (currentState.dataFilters.dataFilter !== null) {
        request = {
            basicFilter: {
                ...currentState.dataFilters.dataFilter,
                ...currentState.dataFilters.dataFilter.basicFilter,
                "channelMapping": credentials
            },
            "struConfigId": currentState.dataFilters.struConfigId
        };
    }
    try {
        const response = await fetch(`/api/saveFilter`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request)
        })
        if (!response.ok) {
            throw new Error('Failed to save the filters');
        }
        return await response.json();
    } catch (error) {
        throw new Error('Failed to save the filters', error);
    }
});



const filtersSlice = createSlice({
    name: "saveFilters",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(saveResponse.pending, (state) => {
            state.status = "loading"
        });
        builder.addCase(saveResponse.fulfilled, (state, action) => {
            state.status = "success"
            state.message = "Data filters saved successfully"
            state.struConfigId = action.payload.data.data.struConfigId
            state.dataFilter = action.payload.data.data.basicFilter
            // state.locale = action.payload.data.data.basicFilter.locale
        });
        builder.addCase(saveResponse.rejected, (state) => {
            state.status = "error"
            state.message = "Data filters failed to save"
        });
        builder.addCase(saveDataFilter.pending, (state) => {
            state.status = "loading"
        });
        builder.addCase(saveDataFilter.fulfilled, (state, action) => {
            state.dataFilter = action.payload.basicFilter
            state.struConfigId = action.payload.struConfigId
        });
        builder.addCase(saveDataFilter.rejected, (state) => {
            state.status = "error"
            state.message = "PIM connection failed"
        });
        builder.addCase(saveFilters.pending, (state) => {
            state.status = "loading"
        });
        builder.addCase(saveFilters.fulfilled, (state, action) => {
            state.status = "success"
            state.message = "Channel mapping saved successfully"
            state.channelMapping = action.payload.data.data.basicFilter.channelMapping
            state.finalData = action.payload.data.data
        });
        builder.addCase(saveFilters.rejected, (state) => {
            state.status = "error"
            state.message = "Channel mapping failed to save"
        });
    }
})

export default filtersSlice.reducer